

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/main.scss'
import axios from 'axios'
import VueAxios from 'vue-axios'
import WOW from 'wow.js'
import 'wow.js/css/libs/animate.css'
import 'element-ui/lib/theme-chalk/index.css' // 改为官方推荐的导入方式
import '@/assets/element-variables.scss' // 如果你有自定义主题变量

import i18n from './lang'

// 关键配置：将ElementUI的i18n与vue-i18n关联
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false;

// 安装插件
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(VueI18n)

// 事件总线 - 保留用于弹窗登录通信
Vue.prototype.$bus = new Vue();

// 初始化WOW动画
const wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: true,
    live: true
});
wow.init();

// 移除全局认证对象和路由守卫注册
// 所有登录逻辑已迁移至Home.vue的弹窗触发模式

// 初始化Vue实例
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
